import {Component, inject, input} from '@angular/core';
import {DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-error-dialog',
  imports: [],
  templateUrl: './error-dialog.html',
  styleUrl: './error-dialog.css',
})
export class ErrorDialog {
  message = input();
  ref = inject(DynamicDialogRef);

  closeDialog() {
    this.ref.close();
  }
}
